<template>
  <div class="box">
    <el-drawer
      :visible.sync="visible"
      :wrapperClosable="false"
      :show-close="false"
      :close-on-press-escape="false"
      custom-class="drawer1"
      :title="title"
      :size="size"
    >
      <div slot="title" style="border-bottom:1px solid #ccc;padding-bottom:10px;">
        “
        <span style="color:red">{{title}}</span>
        ” 项目结项报告列表
      </div>
      <div style="margin:10px">
        <WtDataTable
          ref="tablesRef"
          :search="search"
          :listUrl="$db.config.com_project.end.org_list"
          :urlParams="{project_before_id:this.id}"
        >
          <template slot="columns">
            <el-table-column label="机构名称" min-width="200" prop="unit_name" align="center"></el-table-column>
            <el-table-column prop="if_node_text" label="是否完成结项" align="center" width="120"></el-table-column>
            <el-table-column prop="reg_time" label="提交结项日期" align="center" width="120"></el-table-column>

            <el-table-column label="操作" align="center" width="350" fixed="right">
              <template slot-scope="scope">
                <el-button-group>
                  <el-button
                    type="primary"
                    icon="el-icon-view"
                    size="mini"
                    v-if="Number(scope.row.node_id) > 0"
                    @click="lookReport(scope.row)"
                  >查看机构结项报告</el-button>
                  <span v-else style="color:red">未结项</span>
                </el-button-group>
              </template>
            </el-table-column>
          </template>
        </WtDataTable>
      </div>

      <el-dialog :visible.sync="show_end" width="50%" @close="cancelBtn" append-to-body>
        <div slot="title" style="border-bottom:1px solid #ccc;padding-bottom:10px;">
          “
          <span style="color:red">{{end_title}}</span>
          ” -- 项目结项报告
        </div>

        <div>
          <p style="padding:0px 5px 5px">
            结项发起人：
            {{endForm.apply_user_name}}
          </p>

          <p style="padding:5px">
            结项时间：
            {{endForm.node_time}}
          </p>

          <p style="padding:5px">
            结项附件：
            <!-- <span
              @click="downFile(endForm.file_id, endForm.file_source_name)"
              style="text-decoration: underline; color: #333; cursor: pointer;color:#4682B4 "
            >{{ endForm.file_source_name }}</span> -->
            <a
              :href="endForm.file_url"
              target="_blank"
            >{{endForm.file_source_name}}</a>
          </p>

          <p style="padding:5px">
            结项原因:
            {{endForm.reasons}}
          </p>
          <p style="padding:5px">
            项目摘要：
            <span class="span_box">
              本项目自
              <i>{{abstract.regdate_start}}</i>至
              <i>{{abstract.regdate_end}}</i> 的实施期间，累计受益总人数为
              <i>{{abstract.beneficiary_number}}</i>，其中筛查
              <i>{{abstract.screen_sum}}</i>人，
              筛查出的患者中有
              <i>{{abstract.apply_count}}</i>名入院复诊接受治疗，合计使用该项目款
              <i>{{abstract.approve_sum}}</i> 元，此外医保补助总额为
              <i>{{abstract.yb_sum}}</i> 元。
            </span>
          </p>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button type="danger" size="small" icon="el-icon-close" @click="cancelBtn">关闭</el-button>
        </span>
      </el-dialog>

      <div class="demo-drawer-footer">
        <el-button type="danger" size="small" icon="el-icon-close" @click="close">关闭</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    size: {
      type: [String, Number],
      default: "75%"
    },
    id: {
      type: [String, Number],
      default: null
    }
  },

  data() {
    return {
      visible: false,
      show_end: false, //查看报告信息
      endForm: {},
      end_title: "",
      search: {},

      defFile: [],
      abstract: {} //结项相关金额
    };
  },

  methods: {
    close() {
      this.visible = false;
    },

    // 查看报告信息
    lookReport(row) {
      this.end_title = row.unit_name;
      this.getProjectEndInfo(row.project_id);
      this.getAbstract(row.project_id);
    },

    //
    cancelBtn() {
      this.show_end = false;
    },

    //获取结项信息详情
    getProjectEndInfo(pid) {
      this.$db
        .post(this.$db.config.getProjectEndInfo, { project_id: pid })
        .then(res => {
          if (res && res.code == 200) {
            this.endForm = res.data;
            this.defFile.push({
              name: res.data.file_source_name,
              url: res.data.file_path,
              id: res.data.file_id
            });
            this.show_end = true;
          }
        });
    },

    //获取项目摘要（结项资料）
    getAbstract(pid) {
      this.$db
        .post(this.$db.config.getProjectPublicNodeTotal, { id: pid })
        .then(res => {
          if (res && res.code == 200) {
            this.abstract = res.data;
          }
        });
    },

    downFile(id, name) {
      this.$db
        .downFilePost(this.$db.config.downloadFileUrl, { file_id: id })
        .then(res => {
          if (res.hasOwnProperty("code")) {
            var enc = new TextDecoder("utf-8");
            var result = JSON.parse(enc.decode(new Uint8Array(res)));
          } else {
            this.download(res, name);
          }
        });
    },
    // 下载文件
    download(data, name) {
      if (!data) {
        return;
      }
      let blob = new Blob([data], { type: "application/octet-stream" });
      let url = window.URL.createObjectURL(blob);
      let alink = document.createElement("a");
      alink.href = url;

      alink.download = name; //文件名
      alink.click();
      this.downConfirm = false;
    }
  },
  watch: {
    visible(val) {
      this.$emit("input", val);
    }
  },
  mounted() {
    this.visible = true;
  }
};
</script>
<style lang="scss" scoped>
.box /deep/ .drawer1 {
  overflow: auto;
}
.demo-drawer-footer {
  width: 75%;
  position: fixed;
  bottom: 0;
  right: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/Hospital/comproject/end/report_list.vue